import { createRouter, createWebHashHistory } from "vue-router"
import BasicLayout from "@/views/layouts/BasicLayout"

export const routes = [
	{
		path: "/",
		name: "index",
		meta: { title: "login" },
		hidemenu: true,
		redirect: "/login",
		children: [
			{
				path: "/login",
				name: "login",
				hidemenu: true,
				meta: { title: "login", authentication_skip: true },
				component: () => import("@/views/login/Login"),
			},
			{
				path: "/register",
				name: "register",
				hidemenu: true,
				meta: { title: "register", authentication_skip: true },
				component: () => import("@/views/login/Register"),
			},
			{
				path: "/resetuser",
				name: "resetuser",
				hidemenu: true,
				meta: { title: "resetuser", authentication_skip: true },
				component: () => import("@/views/login/ResetUser"),
			},
			{
				path: "/openpage",
				name: "openpage",
				hidemenu: true,
				meta: { title: "resetuser", authentication_skip: true },
				component: () => import("@/views/open/OpenPage"),
			},
			{
				path: "/test",
				name: "test",
				hidemenu: true,
				meta: { title: "test", authentication_skip: true },
				component: () => import("@/views/test/test"),
			},
		],
	},
	{
		path: "/home",
		name: "home",
		meta: { title: "home" },
		hidemenu: false,
		component: BasicLayout,
		redirect: "/pl-analyze",
		children: [
			{
				path: "/turnover",
				name: "turnover",
				meta: { title: "Turnover", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/turnover/Turnover"),
				redirect: "/turnovers",
				children: [
					{
						path: "/pl-analyze",
						name: "pl_analyze",
						meta: { title: "Client Award P/L Analysis", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/turnover/pl_analyze/PLAnalyze"),
					},
					{
						path: "/turnovers",
						name: "turnovers",
						meta: { title: "Client Award Information", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/turnover/turnovers/Turnovers"),
					},
					{
						path: "/crewplan",
						name: "crewplan",
						meta: { title: "Client Award Crewplan", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/turnover/crewplan/CrewPlan"),
					},
					{
						path: "/overview",
						name: "overview",
						meta: { title: "Client Award Overview", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/turnover/overview/OverView"),
					},
					// {
					//     path: '/progress',
					//     name: 'progress',
					//     meta: {title: 'TO Progress', role: [1, 2, 3]},
					//     hidemenu: false,
					//     component: () => import('@/views/turnover/progress/Progress'),
					// },
				],
			},
			{
				path: "/show",
				name: "show",
				meta: { title: "Show", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/show/Show"),
				redirect: "/show",
				children: [
					{
						path: "/show/information",
						name: "show information",
						meta: { title: "Show Information", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/show/information/Information"),
					},
					{
						path: "/show/crewplan",
						name: "show crewplan",
						meta: { title: "Show Crewplan", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/show/crewplan/CrewPlan"),
					},
					{
						path: "/show/overview",
						name: "show overview",
						meta: { title: "Show Overview", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/show/overview/OverView"),
					},
					{
						path: "/show/pl-analyze",
						name: "show pl_analyze",
						meta: { title: "Show P/L Analysis", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/show/pl_analyze/PLAnalyze"),
					},
				],
			},
			{
				path: "/stuffing",
				name: "stuffing",
				meta: { title: "Staffing", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/stuffing/Stuffing"),
				redirect: "/dept-overview",
				children: [
					{
						path: "/dept-overview",
						name: "dept_overview",
						meta: { title: "Dept Overview", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/stuffing/dept_overview/DeptOverView"),
					},
					{
						path: "/studio-crew-overview",
						name: "studio-crew-overview",
						meta: { title: "Studio Crew Overview", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import(
								"@/views/stuffing/studio_crew_overview/StudioCrewOverview"
							),
					},
					{
						path: "/resource-overview",
						name: "resource-overview",
						meta: { title: "Resource Overview", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/stuffing/resource_overview/ResourceOverview"),
					},
				],
			},

			{
				path: "/data-center",
				name: "data_center",
				meta: { title: "Data Center", role: [1, 3] },
				hidemenu: false,
				component: () => import("@/views/data_center/DataCenter"),
				children: [
					{
						path: "/timelogs",
						name: "timelogs",
						meta: { title: "Time Logs", role: [1, 3] },
						hidemenu: false,
						component: () => import("@/views/data_center/time_logs/TimeLogs"),
					},
					{
						path: "/tasks",
						name: "task",
						meta: { title: "Tasks", role: [1, 3] },
						hidemenu: false,
						component: () => import("@/views/data_center/task/Tasks"),
					},
					{
						path: "/shot",
						name: "shot",
						meta: { title: "Shots", role: [1, 3] },
						hidemenu: false,
						component: () => import("@/views/data_center/shot/Shot"),
					},
					{
						path: "/user",
						name: "user",
						meta: { title: "Users", role: [1, 3] },
						hidemenu: false,
						component: () => import("@/views/data_center/user/User"),
					},
					{
						path: "/project",
						name: "project",
						meta: { title: "Projects", role: [1, 3] },
						hidemenu: false,
						component: () => import("@/views/data_center/project/Project"),
					},
				],
			},
			{
				path: "/purchaser-showcase",
				name: "purchaser_showcase",
				meta: { title: "Base Showcase", authentication_skip: true },
				hidemenu: false,
				component: () => import("@/views/purchaser_showcase/PurchaserShowcase"),
				children: [
					{
						path: "/reels-video",
						name: "reels-video",
						meta: { title: "Reels", authentication_skip: true },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/Reels"),
					},
					{
						path: "/demo-video",
						name: "demo_video",
						meta: { title: "ShowTracker Demo", authentication_skip: true },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/DemoVideo"),
					},
					{
						path: "/bts-video",
						name: "bts_video",
						meta: { title: "Base BTS", authentication_skip: true },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/BaseBTS"),
					},
					{
						path: "/video-manager",
						name: "video_manager",
						meta: { title: "Video Management", authentication_skip: false, role: [1, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/VideoManager"),
					},
				],
			},
			{
				path: "/person-info",
				name: "person_info",
				meta: { title: "Your Account", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/personal_info/PersonalInfo"),
				children: [
					{
						path: "/service-hours",
						name: "service_hours",
						meta: { title: "Service Hours", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import(
								"@/views/show_finance_tracker/service_hours/service_hours"
								),
					},
					{
						path: "/monthly-account-summary",
						name: "monthly_account_summary",
						meta: { title: "Account Summary", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import(
								"@/views/personal_info/monthly_account_summary/MonthlyAccountSummary"
								),
					},
					{
						path: "/my-transactions",
						name: "my_transactions",
						meta: { title: "Transactions History", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/personal_info/my_transactions/MyTransactions"),
					},
					{
						path: "/deposit-info",
						name: "deposit-info",
						meta: { title: "Bank Deposit Detail", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/personal_info/deposit_info/DepositInfo"),
					},
					{
						path: "/change-password",
						name: "change_password",
						meta: { title: "Change Password", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/personal_info/change_password/ChangePassword"),
					}
				],
			},
			{
				path: "/admin",
				name: "admin",
				meta: { title: "Admin", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/admin/Admin"),
				children: [
					// {
					// 	path: "/add-transaction",
					// 	name: "add_transaction",
					// 	meta: { title: "Add Transaction", role: [1] },
					// 	hidemenu: false,
					// 	component: () =>
					// 		import("@/views/admin/add_transaction/AddTransaction"),
					// },
					{
						path: "/add-transaction-new",
						name: "add_transaction_new",
						meta: { title: "Add Transaction", role: [1] },
						hidemenu: false,
						component: () =>
							import("@/views/admin/add_transaction/AddTransaction_New"),
					},
					{
						path: "/admin-transactions",
						name: "admin_transactions",
						meta: { title: "Admin Transactions", role: [1] },
						hidemenu: false,
						component: () =>
							import("@/views/admin/ecom_transactions/EcomTransactions"),
					},
					{
						path: "/contact-us",
						name: "contact_us",
						meta: { title: "Contact Us", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/admin/contact_us/ContactUs"),
					},
					{
						path: "/control-users",
						name: "control_users",
						meta: { title: "Control Users", role: [1] },
						hidemenu: false,
						component: () => import("@/views/admin/control_users/ControlUsers"),
					},
					{
						path: "/show-logs",
						name: "show_logs",
						meta: { title: "Usage Logs", role: [1] },
						hidemenu: false,
						component: () => import("@/views/admin/show_logs/ShowLogs"),
					},

					{
						path: "/users-info",
						name: "users-info",
						meta: { title: "Users Info", role: [1] },
						hidemenu: false,
						component: () => import("@/views/admin/users_info/UsersInfo"),
					},
					{
						path: "/permission-manager",
						name: "permission-manager",
						meta: { title: "Permission", role: [1] },
						hidemenu: false,
						component: () => import("@/views/user/permission-management"),
					}
				],
			},
			{
				path: "/import-data",
				name: "import_data",
				meta: { title: "Import Data", role: [1] },
				hidemenu: false,
				component: () => import("@/views/import_data/ImportData"),
				children: [
					{
						path: "/import",
						name: "Import",
						meta: { title: "Import", role: [1] },
						hidemenu: false,
						component: () => import("@/views/import_data/import/import"),
					},
				],
			},
		],
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes,
})

export default router
